import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { HeroCanvas, PhoneMockup } from './HeroCanvas';

const BETA_POINTS = ['Full platform access', 'No credit card', 'No commitment'];
const PROOF_POINTS = ['No hardware needed', 'Quick onboarding', 'Android-native', 'Remote-ready'];

/**
 * The home hero. The brand plane, agent mesh and waves now live in
 * HeroCanvas, which /features stands on as well; what remains here is the
 * copy this page alone carries.
 */
const Hero = () => (
  <HeroCanvas>
      <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-10">
        <div>
          <span className="eyebrow accent-brand animate-fade-up">
            <span className="spark-mark" aria-hidden="true" />
            Now in beta — 1 month free
          </span>

          <h1 className="display-heading mt-6 animate-fade-up" style={{ animationDelay: '70ms' }}>
            <span className="display-solid block">Run your entire</span>
            <span className="display-accent block">call center</span>
            <span className="display-solid block">from a smartphone</span>
          </h1>

          <p
            className="mt-6 max-w-xl text-lede leading-relaxed text-content-muted animate-fade-up"
            style={{ animationDelay: '140ms' }}
          >
            WASLX replaces expensive call center infrastructure with a mobile-first platform.
            Deploy in minutes, scale without servers, run from anywhere.
          </p>

          <ul
            className="mt-7 flex flex-wrap gap-x-6 gap-y-2.5 animate-fade-up"
            style={{ animationDelay: '200ms' }}
          >
            {PROOF_POINTS.map(point => (
              <li key={point} className="flex items-center gap-2 text-[0.9375rem] text-content-muted">
                <Check className="h-4 w-4 flex-shrink-0 text-primary-strong" />
                {point}
              </li>
            ))}
          </ul>

          <div
            className="mt-9 flex flex-col gap-3 sm:flex-row animate-fade-up"
            style={{ animationDelay: '260ms' }}
          >
            <Link to="/contact" className="btn-pill btn-pill--primary">
              Join the beta — it's free
              <ArrowRight className="h-[18px] w-[18px]" />
            </Link>
            <Link to="/contact" className="btn-pill">
              Book a demo
            </Link>
          </div>

          <ul
            className="mt-7 flex flex-wrap gap-x-6 gap-y-2 animate-fade-up"
            style={{ animationDelay: '320ms' }}
          >
            {BETA_POINTS.map(point => (
              <li key={point} className="flex items-center gap-1.5 text-sm text-content-muted">
                <Check className="h-3.5 w-3.5 flex-shrink-0 text-success" />
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex animate-fade-in justify-center" style={{ animationDelay: '180ms' }}>
          <PhoneMockup />
        </div>
      </div>
  </HeroCanvas>
);

export default Hero;
